module.exports = __webpack_public_path__ + "assets/img/how_to_module_editable_red.svg";